import { unflatten } from 'flat';

const modules = {};

const register = (files, fileName, key) => {
  key.split('.modules.').reduce((acc, item, index) => {
    if (index) acc.push('modules');
    acc.push(item);
    modules[acc.join('.')] = { namespaced: true };
    return acc;
  }, []);
  modules[key] = { ...files(fileName).default };
};

// global
(() => {
  const files = require.context('.', true, /[a-z0-9-_]+\.js$/i);
  files.keys().forEach(fileName => {
    if (fileName === './index.js') return;
    register(files, fileName, fileName.replace(/(\.\/|\.js)/g, '').replace(/\//g, '.modules.'));
  });
})();

// individual 'store' directory children
(() => {
  const files = require.context('../../views/', true, /store(?!.js)/);
  files.keys().forEach(fileName => {
    register(
      files,
      fileName,
      fileName
        .replace(/(\.\/|\.js)/g, '')
        .replace(/(\/store\/)/g, '/')
        .replace(/\/store([/store]*)$/, '')
        .replace(/\//g, '.modules.'),
    );
  });
})();

// individual 'store.js'
(() => {
  const files = require.context('../../views/', true, /store.js/);
  files.keys().forEach(fileName => {
    register(files, fileName, fileName.replace(/(\.\/|\/store.js)/g, '').replace(/\//g, '.modules.'));
  });
})();

export default unflatten(modules);
